'use strict';

(function ($) {

    $.widget('ui.agCheckboxList', {
        _create: function () {

            var hidden = this.element.find('[data-checkboxList="True"]');

            var json = hidden.val();

            var checkboxes = $(this.element).find("input[type=checkbox]");

            checkboxes.prop("name", "");
            $(this.element).find("input[value=false]").prop("name", "")
                ;
            $.each(checkboxes, function (index, value) {
                if (json.indexOf($(value).attr("id")) > 0) {
                    $(value).prop("checked", true);
                }
            });

            var maxChecks = this.element.attr("data-max-checks");

            this._on(this.element, {
                'change :checkbox': function (event) {

                    var element = this.element.closest("[data-agex='~agCheckboxList']");

                    var checked = element.find(":checkbox:checked");
                    var arrayOfChecks = [];
                    $.each(checked, function (index, value) {
                        arrayOfChecks.push(value.attributes["id"].value);
                    });
                    arrayOfChecks = JSON.stringify(arrayOfChecks);
                    element.find('[data-checkboxList="True"]').val(arrayOfChecks);
                },
                'click :checkbox': function (event) {

                    var element = this.element.closest("[data-agex='~agCheckboxList']");
                    if (event.currentTarget.checked && maxChecks != null && maxChecks < element.find(":checkbox:checked").length) {
                        event.preventDefault();
                    }
                }
            });
        },
    })
})($);














